export type SakhadLoginType = {
  username: string;
  password: string;
};

export type SakhadSendOtpType = {
  username: string;
  mobile: string;
};

export type SakhadVerifyOtpType = {
  answer?: string;
};

export type SakhadConfirmType = {
  sessionId: string;
  answer: string;
};

export const SakhadSendOtpInitData: SakhadSendOtpType = {
  username: "",
  mobile: "",
};

export const SakhadLoginInitData: SakhadLoginType = {
  username: "",
  password: "",
};
export const SakhadVerifyOtpInitData: SakhadVerifyOtpType = {
  answer: "",
};

export const SakhadConfirmInitData: SakhadConfirmType = {
  sessionId: "",
  answer: "",
};

export type SakhadVerifyCaptchaType = {
  answer: string;
};
export const SakhadVerifyCaptchaInitData = {
  answer: "",
};
